import React from 'react';
import Navigation2 from './Navigation2';
import HeroHeader from './HeroHeader';
import BreakBar from './BreakBar';
import './LandingPage1.css';
import FAQPage from './FAQPage';
import StripeFlow from './StripeFlow';
import Footer from './Footer';

import CallModal from './CallModal';
import TestimonialSlider from './TestimonialSlider';

import ProofSection from './ProofSection';
import AudienceSection from './AudienceSection';
import ComparisonSection from './ComparisonSection';
import TimelineSection from './TimelineSection';
import ExpertSlider from './ExpertSlider';
import TrustSection from './TrustSection';

import PlatformShowcase from './PlatformShowcase';
import ChaosWall from './ChaosWall';
import AdCostChart from './AdCostChart';
import ChannelNodes from './ChannelNodes';
import WhatYouGet from './WhatYouGet';
import OnboardingTimeline from './OnboardingTimeline';

import WhyNow from './WhyNow';
import WastedBudget from './WastedBudget';
import TransitionBreak from './TransitionBreak';
import UseCaseSection from './UseCaseSection';
import PricingSection from './PricingSection';
import SignalLines from './SignalLines';

const LandingPage1 = () => {
  return (
    <div className="landing-page">
      <Navigation2 
      actionLink="https://bonusclub.link"
      actionLinkName="Start for free"
      />
      {/* <HeroHeader /> */}
      {/* <StripeFlow /> */}
      <PlatformShowcase />
      {/* <ChaosWall /> */}
      <BreakBar />
      <WhyNow />
      <AdCostChart />
      <WastedBudget />
      <TransitionBreak />
      {/* <ComparisonSection /> */}
      <ChannelNodes />
      {/* <SignalLines /> */}
      {/* <WhatYouGet /> */}
      {/* <OnboardingTimeline /> */}
      {/* <AudienceSection /> */}
      {/* <TimelineSection /> */}
      <TrustSection />
      <ExpertSlider />

      {/* <PricingSection /> */}
      <ProofSection />
      <UseCaseSection />
      <TestimonialSlider />
      <FAQPage />
      <Footer />
      <CallModal />
    </div>
  );
};

export default LandingPage1;
